import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { RadarAutocompleteResponse } from "../models/radar.model";

@Injectable({
    providedIn: 'root'
})
export class RadarEndpointService {
    private http = inject(HttpClient);

    private readonly autocompleteUrl = 'https://api.radar.io/v1/search/autocomplete';

    getAddressOptions(query: string) {
        return this.http.get<RadarAutocompleteResponse>(this.autocompleteUrl, {
            headers: { Authorization: environment.RADAR_API_KEY },
            params: { query, country: 'US', limit: 5, layers: 'address' }
        });
    }
}
